import React, { useState, useEffect } from 'react'

import { Box, InputAdornment, IconButton, TextField, Stack, Typography } from '@mui/material'
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Brightness1OutlinedIcon from '@mui/icons-material/Brightness1Outlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import custom from '../../styles/mui/szVariables.json'
import { analyticsCta, analyticsDomain } from '../../services/constants'
import { sendClickAnalytics } from '../common/util/util'

export const Email: React.FC<{ 
  onBlur?: any;
  email: string; 
  emailIsValid: boolean; 
  onKeyUp: any;
  setEmail: (_: string) => void 
}> = ({
    emailIsValid,
    onBlur,
    setEmail,
    email,
    onKeyUp
  }) => {
  return (
    <>
    <Typography
      variant="szBody.Regular.Medium">
      Email
    </Typography>
    <TextField
      onBlur={onBlur}
      id="email"
      fullWidth
      variant="outlined"
      // label={emailIsValid ? 'Email' : 'Invalid Email'}
      // error={!emailIsValid}
      value={email}
      onKeyUp={onKeyUp}
      onChange={(evt: React.ChangeEvent<HTMLTextAreaElement>) => {
        setEmail(evt.target.value?.trim())
      }}
      InputProps={{
        sx: {
          mt: custom.spacing.xxxs,
          borderRadius: custom.corners3,
          color: 'text.primary', 
          fontFamily: 'GT Pressura Regular', 
          backgroundColor: '#FFF'
        }
      }}
      inputProps={{
        sx: { 
          height: custom.sizes.xl,
          px: custom.spacing.xs,
          py: 0,
         
        }
      }}
    />
    </>
  )
}

export const Password: React.FC<{
  label: string
  passwordIsValid: boolean
  onKeyUp: any
  validation?: Function
  confirmPass?: boolean
  newForm?: boolean
  disabled?: Boolean
  onBlur?: any
  setPassword: (_: string) => void
}> = ({ 
    label, 
    passwordIsValid, 
    onKeyUp,
    setPassword, 
    confirmPass, 
    newForm, 
    disabled, 
    validation, 
    onBlur 
  }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [valid, setValid] = useState({} as any);
  const sendTogglePassword = ()=>{
    sendClickAnalytics('/signin', {
        domain: analyticsDomain.welcome,
        name: analyticsCta.togglePasswordShow,
        metadata: {},
      })
  }
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
    sendTogglePassword()
  };
  const handleMouseDownPassword = () => {
    setShowPassword(!showPassword) 
    sendTogglePassword()
  };
  const handleChange = (evt: React.ChangeEvent<HTMLTextAreaElement>) => {
    setPassword(evt.target.value)
    if(validation) {
      const pass = evt.target.value;
      const val = {
        minLength: evt.target.value.length > 7,
        smallLetter: (/[a-z]/.test(pass)),
        capLetter: (/[A-Z]/.test(pass)),
        digit: (/[0-9]/.test(pass)),
        extraChar: (/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/.test(pass))
      }
      setValid(val)
      validation(
        val.minLength &&
        val.smallLetter &&
        val.capLetter &&
        val.digit &&
        val.extraChar
      )
    }
  }

  // const isPasswordValid = () => {
  //       if(validation && Object.keys(valid).length>0) {          
  //         return passwordIsValid 
  //           && Object.keys(valid).every((k: string)=>valid[k])
  //       }
  //       if(confirmPass===true) {
  //         return false
  //       }
  //       return passwordIsValid 
  // }

  useEffect(() => {
    if(newForm) {
      setValid({})
      setPassword('')
    }
  },[newForm, setPassword])

  const filledCircle = (<CheckCircleIcon 
      sx={{ color: '#009940',  width: '16px', height: '16px' }}/>)
  const circle = (<Brightness1OutlinedIcon 
      sx={{ color: '#D1D1D6', width: '16px', height: '16px'  }}/>)
  return (
    <>
    <Typography
      variant="szBody.Regular.Medium">
      {label}
    </Typography>
    <TextField 
      disabled={!!disabled}
      id={label?.replaceAll(' ','')?.toLowerCase()}
      fullWidth
      type={showPassword ? "text" : "password"}
      variant="outlined"
      // label={isPasswordValid() ? label : 
      //   validation?'Invalid password': 
      //   confirmPass===undefined?'Minimum 8 characters':
      //   confirmPass===true?'Confirm password must be equal to new password':
      //                       'Invalid password'
      // }
      // error={!isPasswordValid()}
      onChange={handleChange}
      onBlur={onBlur}
      onKeyUp={onKeyUp}
      InputProps={{
        sx: {
          mt: custom.spacing.xxxs,
          borderRadius: custom.corners3,
          color: 'text.primary', 
          fontFamily: 'GT Pressura Regular', 
          backgroundColor: '#FFF'
        },
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        )
      }}
      inputProps={{
        sx: { 
          height: custom.sizes.xl,
          px: custom.spacing.xs,
          py: 0,
         
        }
      }}
    />
    {validation?
      <Box width="95%" m={1} >
          <Stack alignItems="center" direction="row" gap={1}>
            {valid.minLength?filledCircle:circle} 
            <Typography variant="szBody.Regular.xSmall" 
                        color={valid.minLength?'text.success':'inherit'}>
                          8 characters long
            </Typography>
          </Stack>
          <Stack alignItems="center" direction="row" gap={1}>
          {valid.smallLetter?filledCircle:circle }
            <Typography variant="szBody.Regular.xSmall" 
              color={valid.smallLetter?'text.success':'inherit'}> 
              At least one lower case letter (a-z)
            </Typography>
          </Stack>
          <Stack alignItems="center" direction="row" gap={1}>
          {valid.capLetter?filledCircle:circle }
            <Typography variant="szBody.Regular.xSmall" 
              color={valid.capLetter?'text.success':'inherit'}>
              At least one upper case letter (A-Z)
            </Typography>
          </Stack>
          <Stack alignItems="center" direction="row" gap={1}>
          {valid.digit?filledCircle:circle }
            <Typography variant="szBody.Regular.xSmall" 
              color={valid.digit?'text.success':'inherit'}>
              At least one number (0-9)
            </Typography>
          </Stack>
          <Stack alignItems="center" direction="row" gap={1}>
          {valid.extraChar?filledCircle:circle }
            <Typography variant="szBody.Regular.xSmall" 
              color={valid.extraChar?'text.success':'inherit'}>
              At least one special characters 
            </Typography>
          </Stack>
        </Box>
    :<></>}
  </>
  )
}

export const Username: React.FC<{ 
  usernameIsValid: boolean; 
  setUsername: (_: string) => void 
}> = ({
    usernameIsValid,
    setUsername,
  }) => {
  return (
    <TextField
      id="username"
      fullWidth
      variant="outlined"
      label={usernameIsValid ? 'Username' : 'Minimum 8 characters'}
      error={!usernameIsValid}
      onChange={(evt: React.ChangeEvent<HTMLTextAreaElement>) => {
        setUsername(evt.target.value)
      }}
    />
  )
}

export const Code: React.FC<{ 
  codeIsValid: boolean; 
  setCode: (_: string) => void 
}> = ({
    codeIsValid,
    setCode,
  }) => {
  return (
    <TextField
      id="code"
      fullWidth
      variant="outlined"
      label={codeIsValid ? 'Code' : 'Minimum 6 characters'}
      error={!codeIsValid}
      onKeyPress={(event: any)=>(/[0-9]/i.test(event.key) || event.key === 'Enter')}
      onChange={(evt: React.ChangeEvent<HTMLTextAreaElement>) => {
        setCode(evt.target.value)
      }}
    />
  )
}
